import styled from 'react-emotion'
import Colors from '../../../themes/Colors'
import {
  Typo30PumpkinOrangeDI,
  Typo20PumpkinOrangeDDI
} from '../../../themes/Fonts/Din2014'
import { mobile } from '../../../utils/mixins'

export const SectionContainer = styled('section')`
  background-color: ${Colors.darkTwoDefault};
  padding-top: 60px;
  padding-bottom: 60px;
  ${mobile} {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`

export const SectionWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DesktopText = styled(Typo30PumpkinOrangeDI)`
  line-height: 1.4;
  letter-spacing: 0.5px;
  text-align: center;
  margin-bottom: 0px;
  @media (max-width: 767px) {
    display: none;
  }
`
export const MobileText = styled(Typo20PumpkinOrangeDDI)`
  line-height: 1.05;
  letter-spacing: normal;
  text-align: center;
  margin-bottom: 0px;
  @media (min-width: 768px) {
    display: none;
  }
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/FooterMessageSection/styledComponents.js